// extracted by mini-css-extract-plugin
module.exports = {"cartUrgencyBox":"Header_cartUrgencyBox__bgLWG"};